import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import LogOutButton from '../LogOutButton/LogOutButton';
import './Nav.css';
import logo from "../../images/image.png";
import HomeIcon from '@material-ui/icons/Home';
import CreateIcon from '@material-ui/icons/Create';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import HistoryIcon from '@material-ui/icons/History';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import DescriptionIcon from '@material-ui/icons/Description';
import EditIcon from "@material-ui/icons/Edit";
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import { Hidden } from '@material-ui/core';

const Nav = (props) => (
  <div className="nav">
    <Link to="/home" className="logo">
      <img
        className="logo"
        src={logo}
        alt="legacy foundation logo"
      />
    </Link>

    <div className="nav-right">
      <Link className="nav-link" to="/home">
        {/* Show this link if they are logged in or not,
        but call this link 'Home' if they are logged in,
        and call this link 'Login / Register' if they are not */}
        {props.user.id ? (
          <>
            <HomeIcon></HomeIcon> Home
          </>
        ) : (
          <>
            <ExitToAppIcon></ExitToAppIcon> Login
          </>
        )}
      </Link>
      {/* Show the link to the info page and the logout button if the user is logged in */}
      {props.user.id && props.user.role === "admin" && (
        <>
          <Link className="nav-link" to="/totalstudententries">
            <FormatListBulletedIcon></FormatListBulletedIcon>
            <Hidden xsDown>Payday Entries</Hidden>
          </Link>

          <Link className="nav-link" to="/adminmakeentry" title="Make Student Entry">
            <EditIcon></EditIcon>
            <Hidden smDown>Make Student Entry</Hidden>
          </Link>

          <Link className="nav-link" to="/pastadminreports" title="Past Reports/Trip Eligibility">
            <HistoryIcon></HistoryIcon>
            <Hidden smDown>Past Reports/Trip Eligibility</Hidden>
          </Link>

          <Link className="nav-link" to="/deductionlist" title="Past Deductions">
            <PlaylistAddCheckIcon/>
            <Hidden smDown>Past Deductions</Hidden>
          </Link>

          <Link className="nav-link" to="/chargestudent" title="Create New Deduction">
            <CreditCardIcon></CreditCardIcon>
            <Hidden smDown>Create New Deduction</Hidden>
          </Link>

          <Link className="nav-link" to="/adminusers" title="Admin Users">
            <SupervisorAccountIcon></SupervisorAccountIcon>
            <Hidden smDown>Admin Users</Hidden>
          </Link>

          <Link className="nav-link" to="/import-bookkeeping" title="Admin Users">
            <ImportContactsIcon/>
            <Hidden smDown> Import Bookkeeping</Hidden>
          </Link>

          <LogOutButton className="nav-link" />
        </>
      )}

      {props.user.id && props.user.role === "student" && (
        <>
          <Link className="nav-link" to="/makeentry">
            <CreateIcon></CreateIcon>
            Make an Entry
          </Link>
          <Link className="nav-link" to="/paststudententries">
            <FormatListBulletedIcon></FormatListBulletedIcon>
            Past Entries
          </Link>
          <LogOutButton className="nav-link" />
        </>
      )}
      {/* Always show this link since the about page is not protected */}
      {/* <Link className="nav-link" to="/about">
        About
      </Link> */}
    </div>
  </div>
);

// Instead of taking everything from state, we just want the user
// object to determine if they are logged in
// if they are logged in, we show them a few more links
// if you wanted you could write this code like this:
// const mapStateToProps = ({ user }) => ({ user });
const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(Nav);
